import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator';
import { DateTextFieldValidator } from '../../../validations/date-text-field.validator';
import { DrugPlan } from '../../models/drug-plan';
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component';
import { PlanList } from '../../models/plan-list';
import { EnrollmentGateway } from '../../gateways/enrollment-gateway';
import { EnrollmentViewModel } from '../../models/enrollment-view-model';
import { GenderPref } from '../../models/gender-pref';

@Component({
	selector: 'genderPref',
	templateUrl: 'gender-pref.component.html',
	styleUrls: ['gender-pref.component.scss'],
})
export class GenderPrefComponent implements OnInit {
	@Input() disabled: boolean = false;
	@Output() onValueChange: EventEmitter<DrugPlan> = new EventEmitter<DrugPlan>();
	notBlankValidator = new NotBlankGenericFieldValidator();
	validatedDate = new DateTextFieldValidator();
	isValidAgent: boolean;
	planYear: number;
	public optionrbPlan: ValidatedRadioButtonModel[] = [];
	planList: PlanList[] = [] as PlanList[];
	selPlan: string;
	AppDate: Date;
	EffectiveDate: Date;
	formValue: string;
	spnyouthey: string;
	spnyourhisher: string;
	spnYourTheir: string;
	AgentFullName: string;
	enrol: EnrollmentViewModel = {} as EnrollmentViewModel;

	@Input() isSpanish: boolean;
	@Input() AgentOrgID: Number;

	@Input() enrollmentgenderPrefyViewModel: EnrollmentViewModel;
	genderPref: GenderPref[] = [] as GenderPref[];
	currentGender: GenderPref[] = [] as GenderPref[];
	repYourSelf: GenderPref[] = [] as GenderPref[];

	currentGenderOptions: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[];
	repYourSelfOptions: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[];
	isyourSelfOther: boolean = false;
    iscurrentGenderOther: boolean = false;
    isGenderComponentVisible: boolean = false;

	constructor(private _enrollmentGateway: EnrollmentGateway) {}

	ngOnInit() {
		 this.loadData();
	}

	loadData() {
		var gendPref = 'ALL';
		this._enrollmentGateway.getGenderData(gendPref).subscribe((model: GenderPref[]) => {
			this.genderPref = model;

			if (this.genderPref !== undefined && this.genderPref !== null) {
				this.genderPref.forEach((element, index) => {
					if (element.GenderPrefListCode.toUpperCase() == 'CURRENTGENDER') {
						this.currentGender.push(element);
					} else if (element.GenderPrefListCode.toUpperCase() == 'GENDERPRONOUN') {
						this.repYourSelf.push(element);
					}
				});

				this.currentGender.sort((a, b) => a.DisplayColumn - b.DisplayColumn);
				this.repYourSelf.sort((a, b) => a.DisplayColumn - b.DisplayColumn);

                this.currentGenderOptions = [] as ValidatedRadioButtonModel[];
                this.currentGender.forEach((gender) => {
                    let newElectionOption = {} as ValidatedRadioButtonModel;
                    newElectionOption.value = gender.DM46Code.toString();
                    newElectionOption.htmlLabel = gender.GenderPrefListDesc.toString();
                    this.currentGenderOptions.push(newElectionOption);
                });
                this.repYourSelfOptions = [] as ValidatedRadioButtonModel[];
                this.repYourSelf.forEach((gender) => {
                    let newElectionOption = {} as ValidatedRadioButtonModel;
                    newElectionOption.value = gender.DM46Code.toString();
                    newElectionOption.htmlLabel = gender.GenderPrefListDesc.toString();
                    this.repYourSelfOptions.push(newElectionOption);
                });
                this.loadcurrentGenderChanged(this.enrollmentgenderPrefyViewModel.CURRENTGENDER);
                this.loadyourSelfChanged(this.enrollmentgenderPrefyViewModel.GENDERNPRONOUN);
            }
            if (this.enrollmentgenderPrefyViewModel.CURRENTGENDER == '4') {
                this.iscurrentGenderOther = true;
            }
            if (this.enrollmentgenderPrefyViewModel.GENDERNPRONOUN == '4') {
                this.isyourSelfOther = true;
            }
        });
    }

	currentGenderChanged(value: string) {
		if (value === '' || value === undefined) {
			return;
		}

		if (value == '4') {
			this.iscurrentGenderOther = true;
		} else {
			this.iscurrentGenderOther = false;
		}
		this.enrollmentgenderPrefyViewModel.CURRENTGENDEROTH = '';
		this.enrollmentgenderPrefyViewModel.CURRENTGENDER = value;

		this.currentGender.forEach((element, index) => {
			if (this.enrollmentgenderPrefyViewModel.CURRENTGENDER != undefined && this.enrollmentgenderPrefyViewModel.CURRENTGENDER != '') {
				if (
					element.GenderPrefListCode.toUpperCase() == 'CURRENTGENDER' &&
					element.DM46Code == Number(this.enrollmentgenderPrefyViewModel.CURRENTGENDER)
				) {
					this.enrollmentgenderPrefyViewModel.displayCurrentGender = element.GenderPrefListDesc;
				}
			}
		});
	}

    loadcurrentGenderChanged(value: string) {
        if (value === '' || value === undefined) {
            return;
        }

        if (value == '4') {
            this.iscurrentGenderOther = true;
        } else {
            this.iscurrentGenderOther = false;
        }
        this.enrollmentgenderPrefyViewModel.CURRENTGENDER = value;

        this.currentGender.forEach((element, index) => {
            if (this.enrollmentgenderPrefyViewModel.CURRENTGENDER != undefined && this.enrollmentgenderPrefyViewModel.CURRENTGENDER != '') {
                if (
                    element.GenderPrefListCode.toUpperCase() == 'CURRENTGENDER' &&
                    element.DM46Code == Number(this.enrollmentgenderPrefyViewModel.CURRENTGENDER)
                ) {
                    this.enrollmentgenderPrefyViewModel.displayCurrentGender = element.GenderPrefListDesc;
                }
            }
        });
    }

    yourSelfChanged(value: string) {

        if (value === '' || value === undefined) {
            return;
        }

        if (value == '4') {
            this.isyourSelfOther = true;
        } else {
            this.isyourSelfOther = false;
        }
        this.enrollmentgenderPrefyViewModel.GENDERNPRONOUNOTH = '';
        this.enrollmentgenderPrefyViewModel.GENDERNPRONOUN = value;

        this.repYourSelf.forEach((element, index) => {

            if (this.enrollmentgenderPrefyViewModel.GENDERNPRONOUN != undefined && this.enrollmentgenderPrefyViewModel.GENDERNPRONOUN != '') {
                if (element.GenderPrefListCode.toUpperCase() == 'GENDERPRONOUN' && element.DM46Code == Number(this.enrollmentgenderPrefyViewModel.GENDERNPRONOUN)) {
                    this.enrollmentgenderPrefyViewModel.displayGenderProNoun = element.GenderPrefListDesc;
                }
            }
        });
    }

    loadyourSelfChanged(value: string) {

        if (value === '' || value === undefined) {
            return;
        }

        if (value == '4') {
            this.isyourSelfOther = true;
        } else {
            this.isyourSelfOther = false;
        }
        this.enrollmentgenderPrefyViewModel.GENDERNPRONOUN = value;

        this.repYourSelf.forEach((element, index) => {

            if (this.enrollmentgenderPrefyViewModel.GENDERNPRONOUN != undefined && this.enrollmentgenderPrefyViewModel.GENDERNPRONOUN != '') {
                if (element.GenderPrefListCode.toUpperCase() == 'GENDERPRONOUN' && element.DM46Code == Number(this.enrollmentgenderPrefyViewModel.GENDERNPRONOUN)) {
                    this.enrollmentgenderPrefyViewModel.displayGenderProNoun = element.GenderPrefListDesc;
                }
            }
        });
    }
}
